// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pipe_wrapper__3qWOy","pipe":"Pipe_pipe__1GXKT"};